"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJsonapiAiClassificationJobCreation = exports.toCanonicalAiClassificationJobCreation = exports.toJsonapiAiClassificationJob = exports.toCanonicalAiClassificationJob = void 0;
const cel_1 = require("@groupby/enrich-criteria/cel");
const object_1 = require("@groupby/stdlib-core/object");
function toCanonicalAiClassificationJob(job) {
    return {
        id: job.id,
        ...job.attributes,
        createdAt: new Date(job.attributes.createdAt),
        updatedAt: new Date(job.attributes.updatedAt),
        config: { modelId: job.attributes.config.modelId, productFilter: cel_1.parse(job.attributes.config.productFilter) },
    };
}
exports.toCanonicalAiClassificationJob = toCanonicalAiClassificationJob;
function toJsonapiAiClassificationJob(job) {
    const attributes = {
        createdAt: job.createdAt.toISOString(),
        updatedAt: job.updatedAt.toISOString(),
        config: { modelId: job.config.modelId, productFilter: cel_1.format(job.config.productFilter) },
        ...object_1.pick(job, 'progress', 'state', 'result', 'createdBy', 'kind'),
    };
    return {
        id: job.id,
        type: 'Job',
        attributes,
    };
}
exports.toJsonapiAiClassificationJob = toJsonapiAiClassificationJob;
function toCanonicalAiClassificationJobCreation(job) {
    return {
        kind: job.attributes.kind,
        config: { modelId: job.attributes.config.modelId, productFilter: cel_1.parse(job.attributes.config.productFilter) },
    };
}
exports.toCanonicalAiClassificationJobCreation = toCanonicalAiClassificationJobCreation;
function toJsonapiAiClassificationJobCreation(job) {
    return {
        type: 'Job',
        attributes: {
            kind: job.kind,
            config: { modelId: job.config.modelId, productFilter: cel_1.format(job.config.productFilter) },
        },
    };
}
exports.toJsonapiAiClassificationJobCreation = toJsonapiAiClassificationJobCreation;
//# sourceMappingURL=mappers.js.map